import { createMemo } from 'react-use'
import { useModelStore } from '@editorStores'

const guidToElement = (model: PlanarModel, rips: Rip[], lintels: Lintel[]) => {
  const model_elements = [
    ...model.walls,
    ...model.roof_slabs,
    ...model.slabs,
    ...model.beams,
    ...model.purlins,
    ...model.columns,
    ...model.vertical_slabs,
    ...model.vertical_roof_slabs,
    ...model.foundationElements,
  ]

  const reduced_elements = model_elements.reduce((collector, element) => {
    collector[element.guid] = element.element_type
    return collector
  }, {} as Record<string, ElementTypes | undefined>)

  const reduced_rips = rips.reduce((collector, element) => {
    collector[element.position_guid] = 'rips'
    return collector
  }, {} as Record<string, ElementTypes | undefined>)

  const reduced_lintels = lintels.reduce((collector, element) => {
    collector[element.position_guid] = 'lintels'
    return collector
  }, {} as Record<string, ElementTypes | undefined>)

  const reduced_slab_beams = model.vertical_slabs.reduce((collector, element) => {
    if (element.beam) {
      collector[element.beam.guid] = 'slab_beams'
    }
    return collector
  }, {} as Record<string, ElementTypes | undefined>)

  const reduced_roof_slab_beams = model.vertical_roof_slabs.reduce((collector, element) => {
    if (element.beam) {
      collector[element.beam.guid] = 'roof_slab_beams'
    }
    return collector
  }, {} as Record<string, ElementTypes | undefined>)

  return {
    ...reduced_elements,
    ...reduced_rips,
    ...reduced_lintels,
    ...reduced_slab_beams,
    ...reduced_roof_slab_beams,
  }
}

const useMapGuidToElement = createMemo(guidToElement)

const useElementTypes = (): Record<string, ElementTypes | undefined> => {
  const model = useModelStore(state => state.model)
  const rips = useModelStore(state => state.model.rips)
  const lintels = useModelStore(state => state.model.lintels)

  const elementsByType = useMapGuidToElement(model, rips, lintels)

  return elementsByType
}

export default useElementTypes
